const api_url = function () {
  return process.env.NODE_ENV === 'production' ? 'https://nibi.com.co' : '';
};

const apiUrl = api_url();

export default apiUrl;
